import { render, staticRenderFns } from "./IModify.vue?vue&type=template&id=dc67ea90&scoped=true&"
import script from "./IModify.vue?vue&type=script&lang=js&"
export * from "./IModify.vue?vue&type=script&lang=js&"
import style0 from "./IModify.vue?vue&type=style&index=0&id=dc67ea90&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc67ea90",
  null
  
)

export default component.exports